import { render, staticRenderFns } from "./SellerPosts.vue?vue&type=template&id=60f29be1&"
import script from "./SellerPosts.vue?vue&type=script&lang=js&"
export * from "./SellerPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports